<script setup>
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import TabBar from "@/components/TabBar.vue";
import NavBar from "@/components/NavBar.vue";
import BackHome from "@/components/backHome.vue";

library.add(fas, fab, far);
defineProps({
    navBarStatus: {
        type: Boolean,
        default: true,
    },
    backHomeStatus: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: "",
    },
});
</script>

<template>
    <div dir="rtl" id="app-layout-main" class="min-h-screen bg-white overflow-x-clip">
        <NavBar v-show="navBarStatus" />
        <BackHome :title="title" v-if="backHomeStatus" />

        <!-- Landmark for a11y + Lighthouse (single main per page) -->
        <main id="main-content" class="mb-36 h-full min-w-0 w-full pb-4 lg:mb-44 lg:pb-6 xl:mb-48 lg:max-w-[1600px] lg:mx-auto">
            <slot></slot>
        </main>

        <TabBar />
    </div>
</template>
